module.exports = __webpack_public_path__ + "media/flags/014-japan-089566f1.svg";